import { Keys } from '../types';

const keys: Keys = {
  infura: 'f73bdb8028ac4b1d9df636de18f5eb5b',
  alchemy: 'VBeQgTCRqqPtuuEPsFzRdwKXzDyN6aFh',
};

export default keys;
